import {
  Box, Button, Divider, Typography,
} from '@mui/material';
import React from 'react';
import ServiceCenterAutocomplete from '../DealerInfo/ServiceCenterAutocomplete';
import ServiceAdvisorAutocomplete from '../DealerInfo/ServiceAdvisorAutocomplete';

const DealerInfoLayout = ({
  title,
  subtitle,
  control,
  selectedMerchantId,
  onMerchantChange,
  onShowRepairFinder,
  showMerchantSelect,
}) => (
  <>
    <Box>
      <Typography variant="h3" sx={{ mt: '24px', mb: '8px' }}>
        {title}
      </Typography>
      <Typography variant="body1">
        {subtitle}
      </Typography>
    </Box>
    {showMerchantSelect
      && (
      <ServiceCenterAutocomplete
        merchantId={selectedMerchantId}
        onChange={onMerchantChange}
        control={control}
      />
      )}
    <ServiceAdvisorAutocomplete
      merchantId={selectedMerchantId}
      control={control}
    />
    {showMerchantSelect
      && (
      <Button onClick={onShowRepairFinder} variant="text" fullWidth>
        Unable to find the correct service center?
      </Button>
      )}
    <Divider />
  </>
);

export default DealerInfoLayout;
